import React, { useState } from "react";
import useWindowDimensions from "../../_helpers/window-dimensions";
import { useNavigate } from "react-router-dom";

import "../../styles/slides.css";
import { section } from "framer-motion/client";

export const SlideAnim = ({data}) => {

    const { width } = useWindowDimensions();

    const [slideIndex, setSlideIndex] = useState(0);

    const navigateTo = useNavigate();

    React.useEffect(() => {
        let len  = data.length;
        const slide = setInterval(() => {
        setSlideIndex((i) => i === len - 1 ? 0: i + 1);
       }, 10000);
       return () => clearInterval(slide);
    },[slideIndex, data.length])

    return (
        <div 
            className="slider-container"
            style={{width: data.length * width}}
        >
            
                    <div 
                        className="slide-unit"
                        style={{backgroundImage: `url(${data[slideIndex].image})`}}
                    >
                        <div className="anim-text-box">
                            <span className="anim-text">
                                {data[slideIndex].caption}
                            </span>
                            <button 
                                className="learn-button"
                                onClick={() => navigateTo("/services")}
                            >
                                Learn more
                            </button>
                        </div>
                        
                    </div>
        </div>
    )
}